import { TextFieldElement } from "../widgets/Form/TextFieldElement";
import { Button } from "@mui/material";
import { useMutation } from "@graphcommerce/graphql";
import { loginOTPDocument, loginOTPMutationVariables } from "../../graphql/login/loginOTP.gql";
import { useFormContext } from "@graphcommerce/ecommerce-ui";
import { useLoading } from "../../context/loadingContext";
import { useState } from "react";

export default function CodeForm({ setActiveForm, setData }: {
  setActiveForm: (a: string) => void;
  setData: (data: any) => void
}) {
  const [loginOtp] = useMutation(loginOTPDocument);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const methods = useFormContext();

  const { setLoading } = useLoading();

  const handleSubmit = (values: any) => {
    const { mobileNumber } = values as loginOTPMutationVariables;

    setLoading(true);

    loginOtp({
      variables: {
        mobileNumber
      }
    }).then((res) => {
      const { data } = res;
      if (data?.loginOTP?.status === true) {
        setData({ mobileNumber, mode: 'loginOtp' })
        setActiveForm('sendcode');
      } else {
        setErrorMessage('ارسال رمز یکبار مصرف با خطا مواجه شد.')
      }



    }).catch(err => {
      setErrorMessage('ارسال رمز یکبار مصرف با خطا مواجه شد.')
    }).finally(() => setLoading(false));
  }
  return (
    <div className="pt-5">
      {errorMessage && <div className="text-sm text-error-500 font-normal text-center my-4">
        {errorMessage}
      </div>}
      <p className="text-base font-medium">ورود با رمز یک‌بارمصرف</p>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <TextFieldElement
          name="mobileNumber"
          label="تلفن همراه"
          required
          fullWidth
          type="tel"
          variant='standard'
          classes={{ root: "!mt-5" }}
          className="!text-sm"
          color='primary' />


        <div className="flex justify-center items-center mt-4">
          <Button type="submit" variant="contained" color="primary" className="flex bg-primary-500 justify-center">
            ارسال پیامک
          </Button>
        </div>
      </form>
    </div>
  )
}